import React from 'react';
import { IconProps } from '../types/types';

const BELERC20: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><path d="M6.511 6.463h6.642c.775 0 1.52.125 2.215.36C15.398 3.05 12.322 0 8.517 0H1.87C.84 0 0 .84 0 1.87v9.787c0 1.035.84 1.87 1.87 1.87h2.766v-5.2c0-1.029.84-1.864 1.875-1.864Z" fill="#00CBA8"/><path d="M15.367 6.823c0 .08 0 .16-.005.24a6.772 6.772 0 0 1-6.761 6.474H4.635v4.593c0 1.035.84 1.87 1.87 1.87h6.727c3.64 0 6.606-2.87 6.761-6.473.135-3.11-1.84-5.769-4.626-6.704Z" fill="#0DB1F9"/></svg>
);

export default BELERC20;
